import { useQuery } from "@tanstack/react-query";
import { fetchRouteStats } from "../../api/routes";

export function useFetchRouteStats() {
  return useQuery({
    queryKey: ["routes", "stats"],
    queryFn: fetchRouteStats,
    staleTime: 30_000,
    onError: (err) => console.error("Error loading route stats:", err),
  });
}
